import {
    Container,
    Paper,
    Typography,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    CircularProgress
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
import { Turnstile } from "@marsidev/react-turnstile";

export default function DeclarationForm({

    data,

    errors,

    handleChange,

    onBack,

    onSubmit,

    loading,

    turnstileToken,

    setTurnstileToken,

    turnstileError,

    setTurnstileError

}) {

    return (
            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Declaration

                </Typography>

                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)", }}>

                    Please read the declaration below carefully before
                    submitting your New Starter information.

                </Typography>


                <FormControl
                    error={!!errors.declarationConfirmed}
                    sx={{ mb: 4 }}
                >

                    <FormControlLabel

                        control={

                            <Checkbox

                                checked={data.declarationConfirmed}

                                onChange={(event) =>

                                    handleChange({

                                        target: {

                                            name: "declarationConfirmed",

                                            value: event.target.checked

                                        }

                                    })

                                }

                            />

                        }

                        label="I confirm that the information I've given on this form is correct."

                    />

                    <FormHelperText>

                        {errors.declarationConfirmed}

                    </FormHelperText>

                </FormControl>


                <Box

                    sx={{
                        mb: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        pointerEvents: loading ? "none" : "auto",
                        opacity: loading ? 0.6 : 1
                    }}

                >

                    <Turnstile

                        siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}

                        onSuccess={(token) => {

                            setTurnstileToken(token);

                            setTurnstileError("");

                        }}

                        onExpire={() => {

                            setTurnstileToken(null);

                        }}

                        onError={() => {

                            setTurnstileToken(null);

                            setTurnstileError(
                                "Verification failed. Please try again."
                            );

                        }}

                    />

                    {

                        turnstileError && (

                            <Typography
                                color="error"
                                sx={{ mt: 2 }}
                            >

                                {turnstileError}

                            </Typography>

                        )

                    }

                </Box>


                <Box

                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 5
                    }}

                >

                    <Button

                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}

                        disabled={loading}

                    >

                        Back

                    </Button>


                    <Button

                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}

                        disabled={
                            loading ||
                            !turnstileToken
                        }

                        onClick={onSubmit}

                        startIcon={

                            loading
                                ?

                                <CircularProgress
                                    size={18}
                                    color="inherit"
                                />

                                :

                                null

                        }

                    >

                        {

                            loading
                                ?

                                "Submitting..."

                                :

                                "Submit New Starter Form"

                        }

                    </Button>

                </Box>

            </Paper>

    );

}